import React from 'react';
import PageTitle from '../components/pagetitle/PageTitle';


BlogDetails01.propTypes = {
    
};

function BlogDetails01(props) {
    return (
        <div>

            <PageTitle sub='Blog' title='Polisi Pemulangan Dana' />
            
            <section className="tf-blog-detail">
                <div className="tf-container">
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="detail-inner">
                                
                                <div className="content-inner" style={{textAlign:"justify"}}>
                                    {/* <h6 className="title">What Is The Most Fun Thing To Become A Designer?</h6> */}
                                    <p >Segala bentuk bayaran atau sumbangan yang telah dibuat melalui platform Al-Jariyah adalah muktamad dan tidak boleh dikembalikan. Ini termasuk tetapi tidak terhad kepada sumbangan seperti Infaq, Waqaf, Infaq Iftar, dan sebarang sumbangan di bawah kempen-kempen yang ditawarkan di dalam aplikasi.</p><br/>
                                    <p>Polisi ini diguna pakai bagi memastikan kelancaran urus tadbir kewangan dan pengurusan sumbangan yang telah diagihkan atau diperuntukkan kepada penerima manfaat yang ditetapkan.</p>
                                </div>
                                
                                <div className="content-inner" style={{textAlign:"justify"}}>
                                    <p>Sekiranya anda mempunyai sebarang pertanyaan lanjut berkenaan polisi ini atau memerlukan penjelasan, sila hubungi pihak sokongan kami melalui e-mel di:</p><br/>
                                    <p>📧 <b>support@al-jariyah.com</b></p>
                                </div>
                                <div className="content-inner" style={{textAlign:"justify"}}>
                                    <p>Kami komited untuk memberikan perkhidmatan terbaik dan menghargai kepercayaan anda dalam menyokong usaha kebajikan melalui Al-Jariyah.</p>
                                </div>
                                
                            </div>                        
                        </div>                                     
                    </div>
                </div>
            </section>
            
        </div>
    );
}

export default BlogDetails01;